module.exports = __webpack_public_path__ + "img/Rausschwimmen.0f5acdce.jpg";